import React, { useContext, useEffect, useMemo, useState } from 'react';
import { AssetsContextTypes, AssetsProviderProps } from './types';
import { AssetType } from '../../types/types';
import { AssetService } from 'src/services/assets/asset.service';
import { AssetTypes } from 'src/features/asset-details/types/asset';

const AssetsContext = React.createContext<AssetsContextTypes>({} as AssetsContextTypes);

export const useAssetsContext = () => useContext(AssetsContext);

export const AssetsProvider = ({ children, customerId, siteId }: AssetsProviderProps) => {
  const [assets, setAssets] = useState<AssetType[]>([]);

  const wetWellAssets = useMemo(
    () => assets.filter((asset) => asset.assetType === AssetTypes.WET_WELL),
    [assets]
  );

  const pumpAssets = useMemo(
    () => assets.filter((asset) => asset.assetType === AssetTypes.PUMP),
    [assets]
  );

  useEffect(() => {
    if (!customerId || !siteId) return;
    AssetService.getAll(customerId, siteId)
      .then((data) => setAssets(data))
      .catch((error) => console.error(error));
  }, [customerId, siteId]);

  return (
    <AssetsContext.Provider value={{ assets, wetWellAssets, pumpAssets }}>
      {children}
    </AssetsContext.Provider>
  );
};
